// JobListing.js
import React from "react";
import JobCategory from "./Job.category";
import { jobCategoryPlans } from "../assets/plan";

const JobListing = ({
  categorySelection,
  setCategorySelection,
  setJobProfile,
  jobProfile,
  loggedinUser,
  setPaymentReference,
  setJobType,
  close,
}) => {
  const handleCategorySelection = (planName) => {
    setCategorySelection(planName);
    setJobType(planName);
    setJobProfile({ ...jobProfile, jobType: planName });
    if (planName === "Draft") {
      setPaymentReference("N/A");
      close();
    }
  };

  return (
    <section className="">
      <div className="flex items-start justify-center flex-wrap my-4 gap-4">
        {jobCategoryPlans.map((eachPlan, index) => (
          <div className="flex items-center justify-center gap-5 h-fit" key={index}>
            <JobCategory
              plan_name={eachPlan.planName}
              plan_price={eachPlan.credits}
              plan_benefits={eachPlan.benefits}
              success_handler={handleCategorySelection}
              categorySelection={categorySelection}
              setCategorySelection={setCategorySelection}
              setPaymentReference={setPaymentReference}
              setJobType={setJobType}
              close={close}
              loggedinUser={loggedinUser}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default JobListing;










// import React, { useState, useEffect, useRef } from 'react';
// import JobCategory from './Job.category';
// import { jobCategoryPlans } from '../assets/plan';
// import { shuffleArray } from '../Utils/shuffleArray';
// import Chart from 'chart.js/auto';

// const JobListing = ({
//   categorySelection,
//   setCategorySelection,
//   setJobProfile,
//   paymentHandler,
//   jobProfile,
//   loggedinUser,
//   setPaymentReference,
//   setJobType,
//   close,
//   onPlanSelected, // New prop to notify parent of plan selection
// }) => {
//   const [shuffledPlans, setShuffledPlans] = useState(jobCategoryPlans);
//   const [stats, setStats] = useState({ successful: 0, failed: 0, plans: {} });
//   const paymentChartRef = useRef(null);
//   const planChartRef = useRef(null);

//   useEffect(() => {
//     const shuffled = shuffleArray([...jobCategoryPlans]);
//     setShuffledPlans(shuffled);

//     if (loggedinUser?.role === 'superAdmin') {
//       const fetchStats = async () => {
//         try {
//           const response = await fetch(`${process.env.REACT_APP_API_URL}admin/payment-logs`, {
//             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//           });
//           const data = await response.json();
//           if (data.status) {
//             const logs = data.data;
//             const successful = logs.filter(log => log.status === 'success').length;
//             const failed = logs.filter(log => log.status === 'failed').length;
//             const plans = logs.reduce((acc, log) => {
//               acc[log.jobType] = (acc[log.jobType] || 0) + 1;
//               return acc;
//             }, {});
//             setStats({ successful, failed, plans });
//           }
//         } catch (error) {
//           console.error('Failed to fetch stats:', error);
//         }
//       };
//       fetchStats();
//     }
//   }, [categorySelection, loggedinUser]);

//   useEffect(() => {
//     let paymentChart, planChart;

//     if (loggedinUser?.role === 'superAdmin') {
//       if (paymentChartRef.current) {
//         paymentChart = new Chart(paymentChartRef.current, {
//           type: 'pie',
//           data: {
//             labels: ['Successful', 'Failed'],
//             datasets: [{
//               data: [stats.successful, stats.failed],
//               backgroundColor: ['#4CAF50', '#F44336'],
//             }],
//           },
//           options: { responsive: true, maintainAspectRatio: false },
//         });
//       }

//       if (planChartRef.current) {
//         planChart = new Chart(planChartRef.current, {
//           type: 'pie',
//           data: {
//             labels: ['basic', 'standard', 'premium', 'partner with Ejobs'],
//             datasets: [{
//               data: Object.values(stats.plans).length ? Object.values(stats.plans) : [0, 0, 0, 0],
//               backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
//             }],
//           },
//           options: { responsive: true, maintainAspectRatio: false },
//         });
//       }
//     }

//     return () => {
//       if (paymentChart) paymentChart.destroy();
//       if (planChart) planChart.destroy();
//     };
//   }, [stats, loggedinUser]);

//   const handlePlanSelect = (plan) => {
//     if (onPlanSelected) {
//       onPlanSelected(plan); // Notify parent with selected plan
//     }
//   };

//   return (
//     <section className="py-8 px-4 md:px-6 lg:px-8 bg-gray-50 min-h-screen">
//       <div className="flex flex-col items-center justify-center max-w-7xl mx-auto">
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
//           {shuffledPlans.map((eachPlan, index) => (
//             <div key={index} className="w-full">
//               <JobCategory
//                 plan_name={eachPlan.planName}
//                 plan_price={eachPlan.credits}
//                 plan_benefits={eachPlan.benefits}
//                 categorySelection={categorySelection}
//                 setCategorySelection={setCategorySelection}
//                 setPaymentReference={setPaymentReference}
//                 setJobType={setJobType}
//                 onSelect={handlePlanSelect}
//               />
//             </div>
//           ))}
//         </div>
//         {loggedinUser?.role === 'superAdmin' && (
//           <div className="mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-lg w-full max-w-6xl mx-auto">
//             <h2 className="text-xl font-bold mb-6 text-gray-800">Payment & Plan Statistics</h2>
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//               <div className="h-64">
//                 <canvas ref={paymentChartRef} id="paymentChart"></canvas>
//               </div>
//               <div className="h-64">
//                 <canvas ref={planChartRef} id="planChart"></canvas>
//               </div>
//             </div>
//           </div>
//         )}
//         <button
//           onClick={close}
//           className="mt-4 py-2 px-4 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors duration-200"
//         >
//           Close
//         </button>
//       </div>
//     </section>
//   );
// };

// export default JobListing;